// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: prFzY4CsJhDpFsYFo29VMf
// Component: 7LtHkXE9e5

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_idea_hub.module.css"; // plasmic-import: prFzY4CsJhDpFsYFo29VMf/projectcss
import sty from "./PlasmicButtonLinkPrimary.module.css"; // plasmic-import: 7LtHkXE9e5/css

createPlasmicElementProxy;

export type PlasmicButtonLinkPrimary__VariantMembers = {};
export type PlasmicButtonLinkPrimary__VariantsArgs = {};
type VariantPropType = keyof PlasmicButtonLinkPrimary__VariantsArgs;
export const PlasmicButtonLinkPrimary__VariantProps =
  new Array<VariantPropType>();

export type PlasmicButtonLinkPrimary__ArgsType = {
  text?: React.ReactNode;
};
type ArgPropType = keyof PlasmicButtonLinkPrimary__ArgsType;
export const PlasmicButtonLinkPrimary__ArgProps = new Array<ArgPropType>(
  "text"
);

export type PlasmicButtonLinkPrimary__OverridesType = {
  buttonLinkPrimary?: p.Flex<"a">;
};

export interface DefaultButtonLinkPrimaryProps {
  text?: React.ReactNode;
  className?: string;
}

const $$ = {};

function PlasmicButtonLinkPrimary__RenderFunc(props: {
  variants: PlasmicButtonLinkPrimary__VariantsArgs;
  args: PlasmicButtonLinkPrimary__ArgsType;
  overrides: PlasmicButtonLinkPrimary__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  return (
    <p.Stack
      as={"a"}
      data-plasmic-name={"buttonLinkPrimary"}
      data-plasmic-override={overrides.buttonLinkPrimary}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      hasGap={true}
      className={classNames(
        projectcss.all,
        projectcss.a,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.buttonLinkPrimary
      )}
    >
      {p.renderPlasmicSlot({
        defaultContents: (
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__dqLu5
            )}
          >
            {"All"}
          </div>
        ),
        value: args.text,
        className: classNames(sty.slotTargetText)
      })}
    </p.Stack>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  buttonLinkPrimary: ["buttonLinkPrimary"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  buttonLinkPrimary: "a";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicButtonLinkPrimary__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicButtonLinkPrimary__VariantsArgs;
    args?: PlasmicButtonLinkPrimary__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicButtonLinkPrimary__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicButtonLinkPrimary__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicButtonLinkPrimary__ArgProps,
          internalVariantPropNames: PlasmicButtonLinkPrimary__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicButtonLinkPrimary__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "buttonLinkPrimary") {
    func.displayName = "PlasmicButtonLinkPrimary";
  } else {
    func.displayName = `PlasmicButtonLinkPrimary.${nodeName}`;
  }
  return func;
}

export const PlasmicButtonLinkPrimary = Object.assign(
  // Top-level PlasmicButtonLinkPrimary renders the root element
  makeNodeComponent("buttonLinkPrimary"),
  {
    // Helper components rendering sub-elements

    // Metadata about props expected for PlasmicButtonLinkPrimary
    internalVariantProps: PlasmicButtonLinkPrimary__VariantProps,
    internalArgProps: PlasmicButtonLinkPrimary__ArgProps
  }
);

export default PlasmicButtonLinkPrimary;
/* prettier-ignore-end */
